"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var localStorage_1 = __importDefault(require("../storage/localStorage"));
var CampaignService_1 = __importDefault(require("./campaigns/CampaignService"));
var BrowserDetection_1 = __importDefault(require("./environment/BrowserDetection"));
var BrowserEnvironment_1 = __importDefault(require("./environment/BrowserEnvironment"));
var cookie_1 = __importDefault(require("../storage/cookie"));
var Requester_1 = __importDefault(require("./network/Requester"));
/**
 * Initializes service classes that serve as global reusable services
 */
function default_1(configurations, userID, window, logger) {
    var localStorage = new localStorage_1.default(window.localStorage);
    if (localStorage.get('firstVisit') === null)
        localStorage.install();
    else
        localStorage.addMissingAttributes();
    var browserEnvironment = new BrowserEnvironment_1.default(window, localStorage, (0, BrowserDetection_1.default)());
    var cookie = new cookie_1.default();
    var campaignsApi = new Requester_1.default(configurations.api, logger);
    var campaignService = new CampaignService_1.default(campaignsApi, userID, logger);
    return {
        browserEnvironment: browserEnvironment,
        campaigns: campaignService,
        localStorage: localStorage,
        cookie: cookie,
        logger: logger
    };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLHlFQUFrRDtBQUNsRCxnRkFBeUQ7QUFDekQsb0ZBQTZEO0FBQzdELHdGQUFpRTtBQUNqRSw2REFBc0M7QUFFdEMsa0VBQTJDO0FBVTNDOztHQUVHO0FBQ0gsbUJBQ0ksY0FBbUMsRUFDbkMsTUFBYyxFQUNkLE1BQWMsRUFDZCxNQUFjO0lBRWQsSUFBTSxZQUFZLEdBQUcsSUFBSSxzQkFBWSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQTtJQUMxRCxJQUFJLFlBQVksQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDLEtBQUssSUFBSTtRQUFFLFlBQVksQ0FBQyxPQUFPLEVBQUUsQ0FBQTs7UUFDOUQsWUFBWSxDQUFDLG9CQUFvQixFQUFFLENBQUE7SUFFeEMsSUFBTSxrQkFBa0IsR0FBRyxJQUFJLDRCQUFrQixDQUFDLE1BQU0sRUFBRSxZQUFZLEVBQUUsSUFBQSwwQkFBZ0IsR0FBRSxDQUFDLENBQUE7SUFDM0YsSUFBTSxNQUFNLEdBQUcsSUFBSSxnQkFBTSxFQUFFLENBQUE7SUFFM0IsSUFBTSxZQUFZLEdBQUcsSUFBSSxtQkFBUyxDQUFDLGNBQWMsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDOUQsSUFBTSxlQUFlLEdBQUcsSUFBSSx5QkFBZSxDQUFDLFlBQVksRUFBRSxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFFekUsT0FBTztRQUNILGtCQUFrQixvQkFBQTtRQUNsQixTQUFTLEVBQUUsZUFBZTtRQUMxQixZQUFZLGNBQUE7UUFDWixNQUFNLFFBQUE7UUFDTixNQUFNLFFBQUE7S0FDVCxDQUFBO0FBQ0wsQ0FBQztBQXZCRCw0QkF1QkMifQ==